import { createSlice } from "@reduxjs/toolkit";



export const paymentSlice = createSlice({
    name: 'payment',
    initialState: {

        payload: {

        }
    
    },
    reducers: {
        paymentData : (state, action) => {
            state.payload = action.payload

        }
    }
});

export const {paymentData} = paymentSlice.actions;
export default paymentSlice.reducer

